// extracted by mini-css-extract-plugin
export default {"excalidrawWrapper":"ExcalidrawCanvas_excalidrawWrapper__afvKa"};